/**
 * Status pill for a booking intent.
 *
 * This codebase has no shared badge component — every page hand-rolls one — so
 * this follows the closest existing example, crm/components/LeadStageBadge.jsx.
 */
const statusClass = {
  DRAFT: 'bg-gray-200 text-gray-700',
  PRE_BOOKING: 'bg-slate-100 text-slate-700',
  READY_FOR_CONFIRMATION: 'bg-blue-100 text-blue-700',
  CONFIRMING: 'bg-amber-100 text-amber-700',
  CONFIRMED: 'bg-green-100 text-green-700',
  ACTIVE: 'bg-emerald-100 text-emerald-700',
  COMPLETED: 'bg-teal-100 text-teal-700',
  ABANDONED: 'bg-rose-100 text-rose-700',
}

const PreBookingStatusBadge = ({ status = 'PRE_BOOKING', t }) => (
  <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${statusClass[status] || statusClass.PRE_BOOKING}`}>
    {t ? t(`preBookings.statuses.${status}`, status) : status}
  </span>
)

export default PreBookingStatusBadge
